import { render, staticRenderFns } from "./ArticleBlock.vue?vue&type=template&id=7cee682b&"
import script from "./ArticleBlock.vue?vue&type=script&lang=js&"
export * from "./ArticleBlock.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports